import React from 'react';
import ReactDOM from 'react-dom/client';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import { getKeycloak, onKeycloakEvent, KeycloakAuthSessionBridge } from '@modeling/account';
import { setSpaceConfig } from '@modeling/spaces';
import './index.css';
import App from './App';

function resolveDcAuthBaseUrl(): string {
  if (process.env.NODE_ENV !== 'production') {
    return process.env.REACT_APP_DC_AUTH_API_BASE_URL || '';
  }
  return (window as Window & { REACT_APP_DC_AUTH_API_BASE_URL?: string })
    .REACT_APP_DC_AUTH_API_BASE_URL || '';
}

function resolveSpacesApiBaseUrl(): string {
  const authBase = resolveDcAuthBaseUrl().replace(/\/$/, '');
  // @modeling/spaces expects /api/v1/spaces collection root, not /api/v1 dc-auth root.
  return authBase ? `${authBase}/spaces` : '';
}

setSpaceConfig({
  apiConfig: {
    baseUrl: resolveSpacesApiBaseUrl(),
  },
  project: {
    name: 'dc-admin',
    features: {
      invitations: true,
      memberManagement: true,
      archiving: true,
      spaceAdmin: true,
      ancestorRecompute: true,
      directMemberAdd: true,
      createMemberUser: true,
      registerServiceAccountMember: true,
    },
  },
  persistence: {
    enabled: false,
  },
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <ReactKeycloakProvider
    authClient={getKeycloak()}
    onEvent={onKeycloakEvent}
    initOptions={{
      checkLoginIframe: false,
      onLoad: 'check-sso',
    }}
  >
    <KeycloakAuthSessionBridge>
      <ConfigProvider locale={zhCN}>
        <App />
      </ConfigProvider>
    </KeycloakAuthSessionBridge>
  </ReactKeycloakProvider>,
);
